<template>
  <v-dialog v-model="visible" max-width="400" @keydown.esc="reject()" @keydown.enter="accept()">
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <v-card>
      <v-card-title class="headline">
        <v-icon large color="red darken-2">warning</v-icon>
        <v-spacer></v-spacer>
        {{ caption }}
        <v-spacer></v-spacer>
        <v-icon large color="red darken-2">warning</v-icon>
      </v-card-title>
      <v-card-text>
        <div>{{ text }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="rejectColor" @click="reject()">{{ rejectPrompt }}</v-btn>
        <!-- <v-btn type="submit" :color="acceptColor" @click="accept()">{{ acceptPrompt }}</v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ErrorDialog",
  props: {
    acceptColor: {
      type: String,
      required: false,
      default: "green darken-1"
    },
    rejectColor: {
      type: String,
      required: false,
      default: "red darken-1"
    },
    acceptPrompt: {
      type: String,
      required: false,
      default: "Close"
    },
    rejectPrompt: {
      type: String,
      required: false,
      default: "Close"
    }
  },
  data() {
    return {
      visible: false,
      value: "",
      caption: "",
      text: "",
      promise: null,
      promiseResolve: null,
      promiseReject: null
    };
  },
  methods: {
    open(caption, text) {
      this.caption = caption;
      this.text = text;
      this.visible = true;
      this.promise = new Promise((resolve, reject) => {
        this.promiseResolve = resolve;
        this.promiseReject = reject;
      });
      return this.promise;
    },
    accept() {
      this.visible = false;
      this.promiseResolve(this.value);
    },
    reject() {
      this.visible = false;
      this.promiseReject(this.value);
    }
  }
};
</script>
